import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';

import { passSx } from '@gef-ui/material/components/utils';

export const SectionHeader = ({ text, variant = 'h4', sx }) => (
	<Typography color="text.primary" sx={[{ mb: 1 }, ...passSx(sx)]} variant={variant}>
		{text}
	</Typography>
);

SectionHeader.propTypes = {
	sx: PropTypes.object,
	text: PropTypes.string,
	variant: PropTypes.string,
};

export default SectionHeader;
